import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface IArrowIconProps {
    isOpen: boolean;
    className?: string;
}

const ArrowIcon = (props: IArrowIconProps) => {
    const className = classNames('elc-arrow-icon', props.className);
    const image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' preserveAspectRatio='none' stroke-width='1px' %3E%3Cpath d='M1,6 L10,15 L19,6' /%3E%3C/svg%3E")`;

    return (
        <Icon
            className={className}
            size={'xsmall'}
            image={image}
            transform={props.isOpen ? 'rotate(180deg)' : ''}
        />
    );
};

export { ArrowIcon };
